function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "7puwfaok4a",
  cx: 8.5,
  cy: 8.5,
  r: 8.5
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1163 -840) translate(127 269) translate(840 503) translate(196 68)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "ekyk91rjqb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#7puwfaok4a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#245186",
  xlinkHref: "#7puwfaok4a"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M1.043 9.744L3.267 11.088 6.31 8.973 7.747 9.304 9.072 8.645 10.55 9.766 13.626 8.418 15.048 7.236 17.184 8.781 18.038 7.6 14.987 5.393 12.853 7.166 10.749 8.088 9.233 6.938 7.565 7.767 6.008 7.408 3.212 9.352 1.157 8.11 -1.258 9.144 -0.685 10.484z",
  mask: "url(#ekyk91rjqb)"
}))))));

var SvgImgUnderactive = function SvgImgUnderactive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImgUnderactive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/img-underactive.5798d1d2.svg";
export { ForwardRef as ReactComponent };